import { SOCIAL_PLATFORMS } from '~/constants';
import { ContentsApiResponseResultsType } from '~/searchApi';

export type SortByType =
  | 'published_at'
  | 'like_count'
  | 'comment_count'
  | 'engagement_count'
  | 'post_followers_eng_rate'
  | 'impression_count'
  | 'reach_count'
  | 'post_reach_eng_rate'
  | 'saved_count'
  | 'view_count'
  | 'share_count';
export type PostedByType = 0 | 1 | 7 | 30 | 90 | 365 | 'custom';

export type TimeframesType = {
  friendlyValue: string;
  value: PostedByType;
};

export type SortByListType = {
  friendlyValue: string;
  value: SortByType;
};

export type ComparatorType =
  | 'eq'
  | 'contains'
  | 'contains_all'
  | 'gt'
  | 'lt'
  | 'gte'
  | 'lte';

export type FilterType = {
  comparator: ComparatorType;
  name: string;
  value: string | string[] | undefined;
};

export type AddContentStore = {
  isModalOpen: boolean;
  isCustomModalOpen: boolean;
  isContentDetailModalOpen: boolean;
  isEditMode: boolean;
  creatorId: string | undefined;
  contentId: string | undefined;
  blockId: string | undefined;
  filters: FilterType[];
  platforms: string;
  platformOptions: string[];
  sortBy: SortByType;
  postedBy: PostedByType;
  searchQuery: string;
  selectedContent: ContentsApiResponseResultsType[];
  modifiedContents: ContentsApiResponseResultsType[] | null;
  showInShared: boolean;
  callback?: (
    selectedContent?: ContentsApiResponseResultsType[],
    showInShared?: boolean,
  ) => void;
  setIsModalOpen: (
    isOpen: AddContentStore['isModalOpen'],
    creatorId: string | undefined,
    callback?: AddContentStore['callback'],
  ) => void;
  setIsCustomModalOpen: (isOpen: AddContentStore['isCustomModalOpen']) => void;
  setIsContentDetailModalOpen: (
    isOpen: AddContentStore['isContentDetailModalOpen'],
    contentId: string | undefined,
  ) => void;
  setIsEditMode: (
    isEditMode: AddContentStore['isEditMode'],
    blockId: string | undefined,
  ) => void;
  setFilters: (newFilters: FilterType) => void;
  removeFilter: (filterName: string) => void;
  setPlatforms: (platform: string) => void;
  setPlatformOptions: (options: string[]) => void;
  clearPlatformsAndOptions: () => void;
  setSortBy: (sortBy: SortByType) => void;
  setPostedBy: (postedBy: PostedByType) => void;
  resetPostedBy: () => void;
  setSearchQuery: (searchQuery: string) => void;
  setSelectedContent: (content: ContentsApiResponseResultsType[]) => void;
  setModifiedContents: (
    content: ContentsApiResponseResultsType[] | null,
  ) => void;
  setShowInShared: (showInShared: boolean) => void;
  reset: () => void;
};

export type OptionsValueType = 'reels' | 'feed' | 'story';
export type OptionsType = {
  [P in keyof typeof SOCIAL_PLATFORMS]?: {
    friendlyValue: string;
    value: OptionsValueType;
  }[];
};

export const PLATFORM_OPTIONS: OptionsType = {
  [SOCIAL_PLATFORMS.instagram]: [
    {
      friendlyValue: 'Instagram Reels',
      value: 'reels',
    },
    {
      friendlyValue: 'Instagram Stills',
      value: 'feed',
    },
    {
      friendlyValue: 'Instagram Stories',
      value: 'story',
    },
  ],
};
